const CheckImage = (image?: string | null) => image !== 'no_selection'

export { CheckImage }
